import { addYears, parse, format } from 'date-fns';

export const CNPJ_ALPHANUMERIC_ERROR =
  'CNPJ inválido no novo padrão alfanumérico';

export const normalizeCnpj = (cnpj: string | null | undefined) => {
  if (!cnpj) return '';

  return cnpj
    .trim()
    .toUpperCase()
    .replace(/[./-]/g, '');
};

const getCnpjCharValue = (char: string) => char.charCodeAt(0) - 48;

const calculateAlphanumericCnpjDigit = (value: string) => {
  let sum = 0;
  let weight = 2;

  for (let index = value.length - 1; index >= 0; index -= 1) {
    sum += getCnpjCharValue(value[index]) * weight;
    weight = weight === 9 ? 2 : weight + 1;
  }

  const rest = sum % 11;

  return rest === 0 || rest === 1 ? 0 : 11 - rest;
};

export const isValidAlphanumericCnpj = (
  cnpj: string | null | undefined,
): boolean => {
  const normalized = normalizeCnpj(cnpj);

  if (!/^[A-Z0-9]{12}\d{2}$/.test(normalized)) {
    return false;
  }

  if (/[IOQF]/.test(normalized.slice(0, 12))) {
    return false;
  }

  const firstDigit = calculateAlphanumericCnpjDigit(normalized.slice(0, 12));
  const secondDigit = calculateAlphanumericCnpjDigit(
    `${normalized.slice(0, 12)}${firstDigit}`,
  );

  return normalized.endsWith(`${firstDigit}${secondDigit}`);
};

export const isValidCPF = (document: string): boolean => {
  if (typeof document !== 'string') {
    return false;
  }

  // eslint-disable-next-line no-param-reassign
  document = document.replace(/[^\d]+/g, '');

  if (document.length !== 11 || !!document.match(/(\d)\1{10}/)) {
    return false;
  }

  const cpf = document.split('').map(el => +el);

  const rest = (count: number) =>
    ((cpf
      .slice(0, count - 12)
      .reduce((soma, el, index) => soma + el * (count - index), 0) *
      10) %
      11) %
    10;

  return rest(10) === cpf[9] && rest(11) === cpf[10];
};

const initialDateValidation = (data: Date) => {
  if (!data) {
    return false;
  }

  const dataConvertida = parse(
    format(data, 'yyyy-MM-dd'),
    'yyyy-MM-dd',
    new Date(),
  );

  return dataConvertida;
};

export const validateYoungDriver = (data: Date) => {
  const convertedDate = initialDateValidation(data);

  if (convertedDate) {
    if (
      new Date(convertedDate).getTime() >= addYears(new Date(), -18).getTime()
    ) {
      return false;
    }
    return true;
  }
  return false;
};

export const validateOldDriver = (data: Date) => {
  const convertedDate = initialDateValidation(data);

  if (convertedDate) {
    if (new Date().getFullYear() - convertedDate.getFullYear() > 120) {
      return false;
    }
    return true;
  }
  return false;
};
